var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.664 10.08H17.7v1.367H6.288v-1.368H3.314c-.96 0-1.74.78-1.74 1.74v5.459c0 .32.26.58.58.58H6.29v-1.444h11.413v1.444h4.125c.32 0 .58-.26.58-.58v-5.459c0-.96-.78-1.74-1.74-1.74h-.004ZM17.7 17.857v3.285H6.287v-3.285M17.7 10.079V6.14h-1.952a1.21 1.21 0 0 1-1.21-1.21V2.857h-8.25v7.222m8.25-7.222L17.7 6.14",
    stroke: "#381631",
    strokeWidth: 0.635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPrint;